import React, { useState, useEffect } from 'react';
import { API_URL } from '../utils/api';

const ResetPasswordPage = ({ token, email, onSuccess, switchToLogin }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailState, setEmailState] = useState(email || '');

  useEffect(() => {
    setEmailState(email || '');
  }, [email]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setStatus(null);

    if (!token) {
      setError('Missing reset token. Please use the link from your email.');
      return;
    }

    if (!emailState) {
      setError('Email is required.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, email: emailState, password })
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data?.error || 'Failed to reset password');
      }

      setStatus('Password reset successfully. You can now log in with your new password.');
      onSuccess?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-semibold mb-4">Reset Password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm mb-1">Email</label>
          <input
            className="w-full border rounded p-2"
            type="email"
            value={emailState}
            onChange={(e) => setEmailState(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block text-sm mb-1">New Password</label>
          <input
            className="w-full border rounded p-2"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />
        </div>
        <div>
          <label className="block text-sm mb-1">Confirm Password</label>
          <input
            className="w-full border rounded p-2"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={6}
          />
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {status && <div className="text-green-600 text-sm">{status}</div>}
        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
      <div className="text-sm mt-4">
        <button className="text-blue-600 underline" onClick={switchToLogin}>
          Back to login
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
